module.exports = __webpack_public_path__ + "assets/img/本地合作商户@2x.1eb50ee3.png";